"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PPUIStatus = void 0;
var PPUIStatus = /** @class */ (function () {
    function PPUIStatus(localstorage, key) {
        this.localstorage = localstorage;
        this.key = key;
        this.localstorage.init(this.key || "uistatus");
        var data = this.localstorage.load();
        this._uiStatus = data;
    }
    Object.defineProperty(PPUIStatus.prototype, "login", {
        get: function () {
            return this.uiStatus.login;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PPUIStatus.prototype, "toolbar", {
        get: function () {
            return this.uiStatus.toolbar;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PPUIStatus.prototype, "layout", {
        get: function () {
            return this.uiStatus.layout;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PPUIStatus.prototype, "view", {
        get: function () {
            return this.uiStatus.view;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PPUIStatus.prototype, "screens", {
        get: function () {
            return this.uiStatus.screens;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PPUIStatus.prototype, "uiStatus", {
        get: function () {
            return this._uiStatus;
        },
        enumerable: false,
        configurable: true
    });
    return PPUIStatus;
}());
exports.PPUIStatus = PPUIStatus;
